import React from 'react';
import styles from './FloatingSearchButton.module.css';

interface FloatingSearchButtonProps {
  text: string;
  usageCount: number;
  position: { x: number; y: number };
  onSearch: () => void;
  onClose: () => void;
  isInModal?: boolean;
}

export const FloatingSearchButton: React.FC<FloatingSearchButtonProps> = ({
  text,
  usageCount,
  position,
  onSearch,
  onClose,
  isInModal = false
}) => {
  // Truncate text if too long
  const maxLength = 40;
  const displayText = text.length > maxLength ? text.substring(0, maxLength) + '...' : text;

  // Format usage count text
  const usageText = usageCount === 0
    ? 'Not found'
    : usageCount === 1
    ? 'Found in 1 class'
    : `Found in ${usageCount} classes`;

  // Prevent click event from bubbling to dismiss handler
  const handleButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onSearch();
  };

  const handleCloseClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    onClose();
  };

  return (
    <div
      data-floating-search-button
      className={`${styles.floatingButton} ${isInModal ? styles.inModal : ''}`}
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`,
        transform: 'translateX(-50%)' // Center horizontally
      }}
      onClick={(e) => e.stopPropagation()} // Prevent dismissal when clicking button
    >
      <button
        className={styles.searchAction}
        onClick={handleButtonClick}
        title={`Search for "${text}"`}
      >
        <span className={styles.icon}>🔍</span>
        <span className={styles.text}>Search "{displayText}"</span>
        {usageCount > 0 && (
          <span className={styles.badge}>{usageText}</span>
        )}
      </button>
      <button
        className={styles.closeButton}
        onClick={handleCloseClick}
        title="Close (Esc)"
        aria-label="Close"
      >
        ×
      </button>
    </div>
  );
};
